import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload = {}) {
    return buildApiUrl(ADMIN_ENDPOINTS.ORDERS_LIST, {
      queryParams: {
        limit: 20,
        sort: 'createdAt',
        order: 'desc'
      }
    })
  },

  parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200 || !raw.data) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch last operations',
        data: [],
      }
    }

    // Format V3 : { data: { data: [...] } } ou { data: { orders: [...] } }
    let orders = Array.isArray(raw.data?.data)
      ? raw.data.data
      : (raw.data?.orders || [])

    // Forcer la limite à 20 si l'API ignore le query param 'limit'
    orders = orders.slice(0, 20)

    // Transformer pour le TableList du Dashboard
    return {
      statusCode: 200,
      message: 'Ok',
      data: orders.map(order => ({
        id: order._id || order.id,
        dishName: order.items?.[0]?.title || order.items?.[0]?.name || order.items?.[0]?.dishName || 'Plat inconnu',
        restaurantName: order.restaurantName || order.restaurant?.name || order.metadata?.restaurantName || 'Restaurant Inconnu',
        customerName: order.summary?.customerName || order.deliveryLocation?.contactName || order.customer?.name || order.metadata?.customerName || 'Client Inconnu',
        date: order.createdAt,
        price: Number(order.total || order.pricing?.total || order.amount || 0),
        dishImage: order.items?.[0]?.image || order.items?.[0]?.dishImage || '',
        status: order.status
      })),
    }
  },
}
